import moment from 'moment'

export const DATE_FORMAT = 'D MMM YYYY'

export const formatDate = (date: moment.MomentInput): string =>
  moment(date).format(DATE_FORMAT)

export const getISODateString = (date: Date): string =>
  moment(date).toISOString(true).slice(0, 10)
